import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import { ErrorBoundary } from "@components/index";
export const GlobalLayout = () => {
  return (
    <ErrorBoundary>
      <Layout className="auth-layout">
        <Outlet />
      </Layout>
    </ErrorBoundary>
  );
};
